<template>
  <div class="mb-2 bg-white p-4 rounded-md">
    <p class="font-bold text-xl pb-2 tracking-tight text-gray-900">
      {{ $t("Seller informations") }}
    </p>
    <div>
      <SellerCombobox :sellerCompleteName="localSellerCompleteName" @selectedSeller="handleSelectSeller" />
    </div>
  </div>
</template>

<script>
import SellerCombobox from "@/components/pos/subscription/formwithsteps/SellerCombobox.vue";

export default {
  components: {
    SellerCombobox,
  },
  props: {
    sellerCompleteName: String,
  },
  data() {
    return {
      localSellerCompleteName: this.sellerCompleteName || "",
    };
  },
  watch: {
    sellerCompleteName(newValue) {
      this.localSellerCompleteName = newValue || "";
    },
  },
  methods: {
    handleSelectSeller(seller) {
      this.localSellerCompleteName = seller ? seller.name : "";
      this.$emit("selectedSeller", seller);
    },
  },
};
</script>
